import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from 'react-apexcharts';
import Paper from '@material-ui/core/Paper';

class ReqNotAccepted extends Component {

  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: 'Pedidos encaminhados e não aceites',
        align: 'center',
        margin: 40,
        style: {
          fontSize:  '14px',
          fontWeight:  'bold',
          color:  '#263238'
        }
      },
      labels: [
        'Desde sempre', 
        'Período de tempo:'
      ],
      legend: {
        show: true,
        position: "bottom",
        fontSize: '13px'
      },
     colors:['#264d73', '#20B2AA']
    }
  }

  render() {

    return (
      <div class=" mt-4">
        <br/>
        {this.props.reqNotAccepted && (
        <Chart 
          title={this.state.title}
          options={this.state.chartOptions} 
          series={[this.props.reqNotAccepted[0].n_aceites_dsd_sp, 
                   this.props.reqNotAccepted[0].n_aceites_ultimos_3_meses]}
          type="pie" 
          width="480"
          style={{marginLeft:10, marginBottom:20}}
        /> 
        )}
        {this.props.filter_slider && this.props.filter_slider != null ?
          <div class="label_slider1_dates">definido no filtro</div> : <div class="label_slider1_predef">últimos 90 dias</div>
        }
        <div class="h5 text-center mt-2 mr-4 pr-4 ml-4 pl-4 pt-4">
          <Paper elevation={5}> 
            <div class="mb-4">
              {this.props.reqNotAccepted && (
              <span class="small p-4">Acumulados desde sempre: <span class=""> {this.props.reqNotAccepted[0].n_aceites_dsd_sp} </span></span>
              )}
            </div> 
          </Paper>
        </div>
      </div>
    );
  }
}
export default ReqNotAccepted;
